export const REFRESH_PASSWORD_OLD_PASSWORD = "old_password";
export const REFRESH_PASSWORD_PASSWORD = "password";
export const REFRESH_PASSWORD_PASSWORD_CONFIRMATION = "password_confirmation";
